export const SET_PROFILE = (state, payload) => {
  state.profile = payload;
};

export const SET_PROFILE_LOADER = (state, payload) => {
  state.loading = payload;
};

export const SET_PROFILE_STATUS = (state, payload) => {
  state.status = payload;
};
